
export { LucideIcon } from "/codebuild/output/src1227593752/src/packages/shared-components/src/components/LucideIcon.tsx"